import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Play, Volume2 } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";
import { tryGreetingVoice } from "../../api/greetingVoices";
import { clockParams } from "../../utils/greetingSlot";
import { audioFromBase64, playBase64Mp3 } from "../../utils/audioUnlock";

// صف صوت واحد: استمع له بالجملة الحقيقية ثم اختره.
export const VoiceRow = ({ voice, label, lang, name, speed, tone, selected, onSelect }) => {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);

  const listen = async () => {
    setBusy(true);
    try {
      const { h, d } = clockParams();
      const data = await tryGreetingVoice({ voice, lang, name, speed, tone, hour: h, weekday: d });
      if (!data?.audio) return;
      const audio = audioFromBase64(data.audio, data.mime);
      try {
        await audio.play();
      } catch {
        await playBase64Mp3(data.audio);
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className={`flex items-center justify-between gap-2 rounded-2xl px-3 py-2 ${
        selected ? "shadow-neu-in" : "shadow-neu-sm"
      }`}
      data-testid={`voice-row-${voice}`}
    >
      <span className="flex items-center gap-2 text-xs font-bold">
        <Volume2 className={`h-3.5 w-3.5 ${selected ? "text-primary" : "text-muted-foreground"}`} />
        {label || voice}
      </span>
      <div className="flex items-center gap-2">
        <NeuButton
          type="button"
          className="px-2 py-1 text-[11px]"
          data-testid={`voice-listen-${voice}`}
          disabled={busy}
          onClick={listen}
        >
          <Play className="h-3 w-3" /> {t("greeting.listen")}
        </NeuButton>
        <NeuButton
          type="button"
          variant={selected ? "primary" : undefined}
          className="px-2 py-1 text-[11px]"
          data-testid={`voice-pick-${voice}`}
          onClick={() => onSelect(voice)}
        >
          {selected ? t("greeting.picked") : t("greeting.pick")}
        </NeuButton>
      </div>
    </div>
  );
};
